import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// import axios from 'axios'
import * as _ from 'lodash';
// import consts from '@/common/consts'
import advertisementApi from '@/api/advertisementApi';
import moment from 'moment';
var state = {
  // 上画列表
  advertisementList: [],
  advertisementParams: [],
  // 所有客户列表
  allAdCustomersList: [],
  adCustomersList: [],
  adCustomersParams: {},
  // 司机提现列表
  allDriverReceiveGiftMoneyLogs: [],
  driverReceiveGiftMoneyLogs: [],
  driverReceiveGiftMoneyParams: {},
  //礼品列表
  allGiftList: [],
  giftList: [],
  giftParams: {},
  //项目
  adInstallmentsList: [],
  adInstallmentsParams: {}
};
var mutations = {
  ADVERTISEMENT_LIST: function ADVERTISEMENT_LIST(state, data) {
    state.advertisementList = data;
  },
  ADVERTISEMENT_PARAMS: function ADVERTISEMENT_PARAMS(state, data) {
    state.advertisementParams = data;
  },
  ALLGIFT_LIST: function ALLGIFT_LIST(state, data) {
    state.allGiftList = data;
  },
  GIFT_LIST: function GIFT_LIST(state, data) {
    state.giftList = data;
  },
  GIFT_PARAMS: function GIFT_PARAMS(state, data) {
    state.giftParams = data;
  },
  ALLADCUSTOMERS_LIST: function ALLADCUSTOMERS_LIST(state, data) {
    state.allAdCustomersList = data;
  },
  ADCUSTOMERS_LIST: function ADCUSTOMERS_LIST(state, data) {
    state.adCustomersList = data;
  },
  ADCUSTOMERS_PARAMS: function ADCUSTOMERS_PARAMS(state, data) {
    state.adCustomersParams = data;
  },
  ALLDRIVERRECEIVE_LIST: function ALLDRIVERRECEIVE_LIST(state, data) {
    state.allDriverReceiveGiftMoneyLogs = data;
  },
  DRIVERRECEIVE_LIST: function DRIVERRECEIVE_LIST(state, data) {
    state.driverReceiveGiftMoneyLogs = data;
  },
  DRIVERRECEIVE_PARAMS: function DRIVERRECEIVE_PARAMS(state, data) {
    state.driverReceiveGiftMoneyParams = data;
  },
  ADINSTALLMENTS_LIST: function ADINSTALLMENTS_LIST(state, data) {
    state.adInstallmentsList = data;
  },
  ADINSTALLMENTS_PARAMS: function ADINSTALLMENTS_PARAMS(state, data) {
    state.adInstallmentsParams = data;
  }
};
var actions = {
  loadAdPastePictureLogs: function () {
    var _loadAdPastePictureLogs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('ADVERTISEMENT_PARAMS', params);
            _context.prev = 2;
            _context.next = 5;
            return advertisementApi.loadAdPastePictureLogs(params);
          case 5:
            lostResp = _context.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context.next = 12;
              break;
            }
            commit('ADVERTISEMENT_LIST', data);
            return _context.abrupt("return", lostResp);
          case 12:
            commit('ADVERTISEMENT_LIST', []);
            return _context.abrupt("return", Promise.reject(message));
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", Promise.reject('异常：' + _context.t0));
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 16]]);
    }));
    function loadAdPastePictureLogs(_x, _x2) {
      return _loadAdPastePictureLogs.apply(this, arguments);
    }
    return loadAdPastePictureLogs;
  }(),
  loadAllAdDriverGifts: function () {
    var _loadAllAdDriverGifts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit, form, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            form = {
              page: 1,
              size: 999
            };
            _context2.prev = 2;
            _context2.next = 5;
            return advertisementApi.loadAdDriverGifts(form);
          case 5:
            lostResp = _context2.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context2.next = 12;
              break;
            }
            commit('ALLGIFT_LIST', data);
            return _context2.abrupt("return", lostResp);
          case 12:
            commit('ALLGIFT_LIST', []);
            return _context2.abrupt("return", Promise.reject(message));
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", Promise.reject('异常：' + _context2.t0));
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 16]]);
    }));
    function loadAllAdDriverGifts(_x3) {
      return _loadAllAdDriverGifts.apply(this, arguments);
    }
    return loadAllAdDriverGifts;
  }(),
  loadAdDriverGifts: function () {
    var _loadAdDriverGifts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            commit('GIFT_PARAMS', params);
            _context3.prev = 2;
            _context3.next = 5;
            return advertisementApi.loadAdDriverGifts(params);
          case 5:
            lostResp = _context3.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context3.next = 12;
              break;
            }
            commit('GIFT_LIST', data);
            return _context3.abrupt("return", lostResp);
          case 12:
            commit('GIFT_LIST', []);
            return _context3.abrupt("return", Promise.reject(message));
          case 14:
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", Promise.reject('异常：' + _context3.t0));
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 16]]);
    }));
    function loadAdDriverGifts(_x4, _x5) {
      return _loadAdDriverGifts.apply(this, arguments);
    }
    return loadAdDriverGifts;
  }(),
  loadAllAdCustomers: function () {
    var _loadAllAdCustomers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4) {
      var commit, form, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            form = {
              page: 1,
              size: 999
            };
            _context4.prev = 2;
            _context4.next = 5;
            return advertisementApi.loadAdCustomers(form);
          case 5:
            lostResp = _context4.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context4.next = 12;
              break;
            }
            commit('ALLADCUSTOMERS_LIST', data);
            return _context4.abrupt("return", lostResp);
          case 12:
            commit('ALLADCUSTOMERS_LIST', []);
            return _context4.abrupt("return", Promise.reject(message));
          case 14:
            _context4.next = 19;
            break;
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", Promise.reject('异常：' + _context4.t0));
          case 19:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 16]]);
    }));
    function loadAllAdCustomers(_x6) {
      return _loadAllAdCustomers.apply(this, arguments);
    }
    return loadAllAdCustomers;
  }(),
  loadAdCustomers: function () {
    var _loadAdCustomers = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            commit('ADCUSTOMERS_PARAMS', params);
            _context5.prev = 2;
            _context5.next = 5;
            return advertisementApi.loadAdCustomers(params);
          case 5:
            lostResp = _context5.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context5.next = 12;
              break;
            }
            commit('ADCUSTOMERS_LIST', data);
            return _context5.abrupt("return", lostResp);
          case 12:
            commit('ADCUSTOMERS_LIST', []);
            return _context5.abrupt("return", Promise.reject(message));
          case 14:
            _context5.next = 19;
            break;
          case 16:
            _context5.prev = 16;
            _context5.t0 = _context5["catch"](2);
            return _context5.abrupt("return", Promise.reject('异常：' + _context5.t0));
          case 19:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 16]]);
    }));
    function loadAdCustomers(_x7, _x8) {
      return _loadAdCustomers.apply(this, arguments);
    }
    return loadAdCustomers;
  }(),
  //司机提现记录
  allAdDriverReceiveGiftMoneyLogs: function () {
    var _allAdDriverReceiveGiftMoneyLogs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
      var commit, form, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit;
            form = {
              page: 1,
              size: 99999,
              isOld: false
            };
            _context6.prev = 2;
            _context6.next = 5;
            return advertisementApi.getAdDriverReceiveGiftMoneyLogs(form);
          case 5:
            lostResp = _context6.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context6.next = 12;
              break;
            }
            commit('ALLDRIVERRECEIVE_LIST', data);
            return _context6.abrupt("return", lostResp);
          case 12:
            commit('ALLDRIVERRECEIVE_LIST', []);
            return _context6.abrupt("return", Promise.reject(message));
          case 14:
            _context6.next = 19;
            break;
          case 16:
            _context6.prev = 16;
            _context6.t0 = _context6["catch"](2);
            return _context6.abrupt("return", Promise.reject('异常：' + _context6.t0));
          case 19:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 16]]);
    }));
    function allAdDriverReceiveGiftMoneyLogs(_x9) {
      return _allAdDriverReceiveGiftMoneyLogs.apply(this, arguments);
    }
    return allAdDriverReceiveGiftMoneyLogs;
  }(),
  getAdDriverReceiveGiftMoneyLogs: function () {
    var _getAdDriverReceiveGiftMoneyLogs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref7.commit;
            commit('DRIVERRECEIVE_PARAMS', params);
            _context7.prev = 2;
            _context7.next = 5;
            return advertisementApi.getAdDriverReceiveGiftMoneyLogs(params);
          case 5:
            lostResp = _context7.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context7.next = 12;
              break;
            }
            commit('DRIVERRECEIVE_LIST', data);
            return _context7.abrupt("return", lostResp);
          case 12:
            commit('DRIVERRECEIVE_LIST', []);
            return _context7.abrupt("return", Promise.reject(message));
          case 14:
            _context7.next = 19;
            break;
          case 16:
            _context7.prev = 16;
            _context7.t0 = _context7["catch"](2);
            return _context7.abrupt("return", Promise.reject('异常：' + _context7.t0));
          case 19:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[2, 16]]);
    }));
    function getAdDriverReceiveGiftMoneyLogs(_x10, _x11) {
      return _getAdDriverReceiveGiftMoneyLogs.apply(this, arguments);
    }
    return getAdDriverReceiveGiftMoneyLogs;
  }(),
  loadAdInstallments: function () {
    var _loadAdInstallments = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref8, params) {
      var commit, lostResp, data, status, message;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref8.commit;
            commit('ADINSTALLMENTS_PARAMS', params);
            _context8.prev = 2;
            _context8.next = 5;
            return advertisementApi.loadAdInstallments(params);
          case 5:
            lostResp = _context8.sent;
            data = lostResp.data, status = lostResp.status, message = lostResp.message;
            if (!(status === '0')) {
              _context8.next = 12;
              break;
            }
            commit('ADINSTALLMENTS_LIST', data);
            return _context8.abrupt("return", lostResp);
          case 12:
            commit('ADINSTALLMENTS_LIST', []);
            return _context8.abrupt("return", Promise.reject(message));
          case 14:
            _context8.next = 19;
            break;
          case 16:
            _context8.prev = 16;
            _context8.t0 = _context8["catch"](2);
            return _context8.abrupt("return", Promise.reject('异常：' + _context8.t0));
          case 19:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[2, 16]]);
    }));
    function loadAdInstallments(_x12, _x13) {
      return _loadAdInstallments.apply(this, arguments);
    }
    return loadAdInstallments;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};